import Vue from "vue";
import { mapGetters } from "vuex";
import {
  formatDateTime,
  stringHelper,
  sizeHelper,
  partInfoHelper
} from "@/components/mixins";
import {
  LoadingSpinner,
  DnFunctionButton
} from "@/components/Elements"
import CurrencyText from "@/components/Elements/CurrencyText.vue";
import DnNumberInput from "@/components/Elements/DnNumberInput.vue"
import PartRequestQuote from "@/components/PartRequestQuote/PartRequestQuote.vue"
import vSelect from "vue-select"
import StockInformationPopover from "@/components/Elements/StockInformationPopover";

// icons
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";


export default Vue.extend({
  name: "PartInfoCondensed",
  components: {
    FontAwesomeIcon,
    vSelect,
    LoadingSpinner,
    CurrencyText,
    DnNumberInput,
    DnFunctionButton,
    PartRequestQuote,
    StockInformationPopover
  },
  mixins: [formatDateTime, stringHelper, sizeHelper, partInfoHelper],
  computed: {
    ...mapGetters([
      "collapseAllPartDescriptionsValue",
      "facingWarehouse",
    ]),
  },
  data: () => ({
    downChevronIcon: faChevronDown,
    upChevronIcon: faChevronUp,
  }),
  watch: {
    collapseAllPartDescriptionsValue(newValue) {
      this.collapsePartDescription = newValue;
    }
  },
  created() {
    this.collapsePartDescription = this.collapseAllPartDescriptionsValue;
  },
  methods: {
    swapIcon() {
      if (this.collapsePartDescription) {
        this.collapsePartDescription = false;
        this.icon = "upChevronIcon";
      } else {
        this.collapsePartDescription = true;
        this.icon = "downChevronIcon";
      }
    },

    isDropShipped(part) {
      return part.FullPartDetails?.ItemCategory === "ZDSH";
      return part.FullPartDetails?.ItemCategory === "ZDSH" || part.FullPartDetails?.ItemCategory === "ZMDS";
    },
    warehouseStockTitle(part) {
      if (this.isDropShipped(part)) {
        return "Drop Shipped"
      } else {
        return null;
      }
    },
    warehouseStockDetail(part) {
      let detail = "";

      if (part.FullPartDetails?.WarehouseStockQuantities[0] != null) {
        detail = part.FullPartDetails.WarehouseStockQuantities[0].WarehouseDescription + ": " + part.FullPartDetails.WarehouseStockQuantities[0].Quantity;
      }

      // Dropship items display gridview stock differently
      if (this.isDropShipped(part) && part.FullPartDetails?.ExternalStockQuantities.length > 0) {
        let totalVendorStockQuantity = 0;
        part.FullPartDetails.ExternalStockQuantities.forEach(x => totalVendorStockQuantity += x.Quantity);

        detail = `Vendor Stock: ${totalVendorStockQuantity}`
      }

      return detail;
    }
  },
});
